import B2BLedger from "../../components/dashboard/B2BLedger";

const B2BLedgerPage = () => {
  return (
    <div className="p-3 md:p-5 space-y-4 bg-gray-50 min-h-screen">
      <B2BLedger />
    </div>
  );
};

export default B2BLedgerPage;
